<template>
  <div class="home-decor" aria-hidden="true">
    <span
      v-if="orbs"
      class="home-decor__orb home-decor__orb--a"
      :class="`home-decor__orb--${variant}`"
    />
    <span
      v-if="orbs"
      class="home-decor__orb home-decor__orb--b"
      :class="`home-decor__orb--${variant}`"
    />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'hero' | 'services' | 'ecosystem' | 'contact';
    orbs?: boolean;
  }>(),
  {
    variant: 'ecosystem',
    orbs: true
  }
);
</script>
